import { render, staticRenderFns } from "./select-empresa.vue?vue&type=template&id=55c54a4b&"
import script from "./select-empresa.vue?vue&type=script&lang=js&"
export * from "./select-empresa.vue?vue&type=script&lang=js&"
import style0 from "./select-empresa.vue?vue&type=style&index=0&id=55c54a4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports